import { useEffect, useState } from 'react'
import { Role } from '../../domain/IRoleRepository'
import { AxiosRoleRepository } from '../../infrastructure/AxiosRoleRepository'

export function useRoles() {
    const [roles, setRoles] = useState<Role[]>([])
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState<string | null>(null)

    useEffect(() => {
        const fetchRoles = async () => {
            try {
                setLoading(true)
                const repository = new AxiosRoleRepository()
                const rolesArray = await repository.getAll()
                setRoles(rolesArray)
                setError(null)
            } catch (err) {
                setError(
                    err instanceof Error ? err.message : 'Error fetching roles'
                )
                setRoles([])
            } finally {
                setLoading(false)
            }
        }

        fetchRoles()
    }, [])

    return { roles, loading, error }
}
